import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import { IApplicationRoot } from 'models';
import App from './App';
import rootReducer from './redux/reducers/rootReducer';

import './index.css';

const env = window.location.hostname === 'www.wartsila.com' ? 'prod' : 'dev';
const baseUrl = `https://d20rdry57v9fzf.cloudfront.net/engineconfig/config/${env}/`;
const configurationUrl = 'questionnaire-configuration.json';
const techDataUrl = 'questionnaire-configuration-techData.json';

Promise.all([
  fetch(`${baseUrl}${configurationUrl}`),
  fetch(`${baseUrl}${techDataUrl}`)
])
  .then(([config, techData]) => {
    config.json().then((configurationResponse) => {
      const configuration = configurationResponse as IApplicationRoot;
      techData.json().then((techDataResponse) => {
        const technicalData = techDataResponse;
        const store = createStore(
          rootReducer,
          {
            appReducer: {
              application: null,
              inputs: new Map(),
              selection: null,
              applicationRoot: configuration,
              stepIndex: 0,
              showResults: false,
              techData: technicalData,
              productToBeSelected: null,
              selectedProduct: null,
              stack: []
            }
          });

        ReactDOM.render(
          (<Provider store={store}><App /></Provider>),
          document.getElementById('root')
        );
      });
    });
  });
